// import profile from "./images/my-avatar.png";
import design from "./images/icon-design.svg";
import dev from "./images/icon-dev.svg";
import api from "./images/icon-api.svg";
import cloud from "./images/icon-cloud.svg";
import project1Image from './images/project-1.png';
import project4Image from './images/project-4.png';
import project5Image from './images/project-5.png';
import project6Image from './images/project-6.png';
import project7Image from './images/project-7.png';
import project9Image from './images/project-9.png';
import project10Image from './images/project-10.png';
import project11Image from './images/project-11.png';
import project12Image from './images/project-12.png';
import project13Image from './images/project-13.png';
import project14Image from './images/project-14.png';
import project15Image from './images/project-15.png';
import project16Image from './images/project-16.png';
import project18Image from './images/project-18.png';
import project19Image from './images/project-19.png';
const finofield_avatar = 'https://finofield.com/assets/logo-BO-rLWNb.png';
const gu_avatar = 'https://galgotiacollege.edu//public/uploads/all/2/PSf8vV9pdHjUb5MhnGpG1hiiJ9Y0c8YYgSAk54Q3.png'
const cu_avatar = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSGIvdkDsEN0-BB5WdM3CfdnaxE5O4FDSEioQ&s';
const rhizicube_avatar = 'https://static.wixstatic.com/media/59608f_e7489f65315d4dc9be121b7dc56d9302~mv2.jpg/v1/fill/w_81,h_81,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/White-Insta-profile-image.jpg'

const Introduction = {
    name: 'Arjun Tripathi',
    profile: 'https://avatars.githubusercontent.com/u/74202760?v=4',
    position: 'Software Engineer',
    email: 'mearjuntripathi@gmail.com',
    birthday: 'April 15, 2002',
    location: 'Varanasi, UP, India',
    twitter: 'https://x.com/mearjuntripathi',
    github: 'https://github.com/mearjuntripathi',
    linkedin: 'https://www.linkedin.com/in/mearjuntripathi/',
    google: 'https://g.dev/mearjuntripathi'
}

const SocialAccount = {
    github: "https://github.com/mearjuntripathi",
    twitter: "https://x.com/mearjuntripathi",
    linkedin: "https://www.linkedin.com/in/mearjuntripathi/",
    google: "https://g.dev/mearjuntripathi"
}

const AboutMe = {
    about_text: `<p>
  I am Arjun Tripathi, a Software Engineer and Technical Trainer with hands-on experience in backend and web development.
  I currently work as a Technical Trainer at <b>Galgotias University</b> and <b>Chandigarh University</b>, where I mentor
  students in core computer science concepts, full-stack development, and real-world project building. My teaching
  approach focuses on practical implementation, industry-aligned skills, and problem-solving.
</p>

<p>
  Alongside training, I actively work as a <b>Backend / Web Developer</b>, building scalable and efficient applications
  using modern technologies. I have experience working with <b>Node.js</b>, <b>Go</b>, <b>REST APIs</b>, <b>gRPC</b>,
  <b>Docker</b>, and frontend tools like <b>React</b>, <b>HTML</b>, <b>CSS</b>, and <b>JavaScript</b>. I have developed
  multiple real-world projects including APIs, web platforms, and interactive applications, ensuring clean
  architecture and production-ready code.
</p>
`,
    resume: "https://drive.google.com/file/d/1FqlWdgTjOQdbf9rFIABqY0qIslt9-3uJ/view?usp=drivesdk",

    service: [
        {
            name: "Programming",
            icon: design,
            about: `I'm as good as in Programming to problem solving and code <b>DSA</b>, and <b>System Design</b>`
        },
        {
            name: "Web development",
            icon: dev,
            about: `High-quality development of sites at the professional level.`
        },
        {
            name: "APIs",
            icon: api,
            about: `Good to develop in API for backend projects with <b>GOlang</b>, <b>Node JS</b>.`
        },
        {
            name: "Cloud Computing",
            icon: cloud,
            about: `I am capable to work in cloud Computing technology using <b>AWS</b>, <b>Azure</b>.`
        }
    ],

    testimonial: [
        {
            name: "Galgotias University",
            pic: gu_avatar,
            dateTime: "2025-05-30",
            displayDate: "30 May, 2025",
            about: `Arjun was engaged to train our students in <b>Data Structures and Algorithms (DSA)</b>. His hands-on approach and practical insights significantly enhanced students' understanding. Arjun's ability to simplify complex concepts and ensure clarity for our students has been invaluable, and we appreciate his dedication to fostering real-world skills in competitive programming and logical reasoning.`
        },
        {
            name: "Chandigarh University",
            pic: cu_avatar,
            dateTime: "2024-03-15",
            displayDate: "29 October, 2024",
            about: `Arjun was engaged to train our students in <b>Data Structures and Algorithms (DSA)</b>, <b>Web Technology</b>, <b>API Development</b>, and <b>Cloud Computing</b>. His hands-on approach and practical insights significantly enhanced students' understanding. Arjun's ability to simplify complex concepts and ensure clarity for our students has been invaluable, and we appreciate his dedication to fostering real-world skills in technology.`
        },
        {
            name: "Finofield",
            pic: finofield_avatar,
            dateTime: "2025-03-15",
            displayDate: "15 March, 2024",
            about: `We hired Arjun to develop our company portfolio, and his work exceeded expectations. With a deep understanding of design and functionality, he crafted a comprehensive portfolio and an intuitive admin panel that perfectly aligns with our brand. Arjun's commitment to client satisfaction, attention to detail, and expertise made the project a success. We couldn't be happier with the results.`
        },
        {
            name: "Rhizicube",
            pic: rhizicube_avatar,
            dateTime: "2022-11-22",
            displayDate: "22 Nov, 2022",
            about: `As a <b>Software Engineer Intern</b> at Rhizicube, Arjun made a meaningful impact on our team. He contributed extensively to <b>API Development</b> and <b>Testing</b>, showcasing his technical proficiency and dedication to high standards. Arjun's collaborative skills and proactive approach were a great asset, making him a highly valued member of our team.`
        }
    ]
}


const ResumeData = {
    Experience: [
        {
            companyName: "Galgotias University",
            jobTitle: "Technical Trainer",
            session: "Jan 2025 — Present",
            about: `As a Technical Trainer, I teach students the fundamentals of Data Structures and Algorithms (DSA), including arrays, linked lists, stacks, queues, trees, graphs, and more. I also cover various algorithms such as sorting, searching, recursion, dynamic programming, and greedy algorithms. My goal is to help students develop problem-solving skills and learn how to implement these concepts in real-world applications.
                <br>
                <b>Skills</b>: C++ · JAVA ·  GitHub · Git · Communication · Problem Solving`
        },
        {
            companyName: "Chandigarh University",
            jobTitle: "Technical Trainer",
            session: "July 2024 — Jan 2025",
            about: `As a Technical Trainer, I teach students the fundamentals of Data Structures and Algorithms (DSA), 
                    providing hands-on training and in-depth knowledge of web technologies, particularly the MERN stack. 
                    I guide students through project development, from building applications to deploying them using Docker, 
                    and testing APIs using Postman. 
                    My role involves ensuring students understand the practical aspects of these technologies and their application in real-world scenarios.
                <br>
                <b>Skills</b>: C++ · JAVA · JavaScript · GitHub · MERN Stack · Postman · JSON · gRPC · Git · Communication · Problem Solving · MySQL · REST APIs`
        },
        {
            companyName: "Rhizicube",
            jobTitle: "Software Engineer Intern",
            session: "July 2022 — Nov 2022",
            about: `I learn allot with this company and understand team work, every employee help me when i face problem and
                I understand how to test APIs and and to attend meetings and understand working process of productions.
                I enhanced my communication skills there, and knowledge skill. I learn allot with this company and
                understand team work, every employee help me when i face problem and I under stand how to test APIs and
                and to attend meetings and understand working process of productions. I enhanced my communication skills
                there, and knowledge skill.
                <br>
                <b>Skills</b>: GitHub · Go (Programming Language) · Postman · JSON · gRPC · Git · Communication · Problem Solving · Zapier · MySQL · Gitlab · REST APIs`
        }
    ],
    Education: [
        {
            title: "Dr. A.P.J. Abdul Kalam Technical University",
            session: "2022 — 2024",
            about: `Master Of Computer Application
                <br>
                <b>8.3 CGPA</b>`
        },
        {
            title: "Mahatma Gandhi Kashi Vidhyapeeth",
            session: "2019 — 2022",
            about: `Bachelor of Computer Application
                <br>
                <b>73 %</b>`
        }
    ],
    Skills: [
        {
            title: "Programming Languages",
            skill: ["C", "C++", "Java", "JavaScript", "PHP", "GO", "HTML/CSS", "Node JS"]
        },
        {
            title: "Library / Frameworks",
            skill: ["ReactJS", "ExpressJS", "Rest API", "Gin", "gRPC", "Socket.io", "WebSocket", "Docker"]
        },
        {
            title: "Tools / Platform",
            skill: ["Postman", "VS Code", "PHPmyAdmin", "Netbeans", "Xampp", "AWS", "Linux"]
        },
        {
            title: "Databases",
            skill: ["MySQL", "MongoDB", "Oracle"]
        }
    ]
}

const Project = [
    {
        title: "Coding Profile Service (Go + GraphQL)",
        pic: project19Image,
        link: "https://https://coding-profile-service-v2-0.onrender.com/",
        codeLink: "https://github.com/mearjuntripathi/coding-profile-service",
        category: "apis",
        skills: ["Go", "GraphQL", "Docker", "goquery", "net/http", "gqlgen"],
        description: `Coding Profile Service is a Go-based backend API that fetches and aggregates competitive programming statistics from multiple platforms like HackerRank, CodeChef, Codeforces, LeetCode, and GeeksforGeeks. It uses official APIs and HTML scraping, wrapped in a modular GraphQL interface for high performance and flexibility.`
    },
    {
        title: "How to create a Segment Tree using CPP",
        pic: "https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fgutw6o821ayc0bp6e0z7.png",
        link: "https://dev.to/mearjuntripathi/segment-tree-59n1",
        codeLink: "https://github.com/mearjuntripathi/Data_Structure_Algorithm/tree/main/Tree/Binary%20Tree/SegmentTree",
        category: "article",
        skills: ["C++", "DSA", "Algorithm", "Tree", "Binary Tree", "Range Query"],
        description: `A Segment Tree is a data structure that stores information about array intervals as a tree. This allows answering range queries over an array efficiently, while still being flexible enough to allow quick modification of the array.`
    },
    {
        title: "Upload Files on Drive With Node.js",
        pic: "https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fcmqwl2ix1k7pxfasqcei.png",
        link: "https://dev.to/mearjuntripathi/upload-files-on-drive-with-nodejs-15j2",
        codeLink: 'https://github.com/mearjuntripathi/nodejs/tree/main/file_upload',
        category: "article",
        skills: ["Node.js", "Express.js", "Google Cloud", "Drive"],
        description: `Google Drive with your Node.js applications, you can harness the robust storage capabilities of Google Cloud. This documentation aims to provide a concise guide on utilizing Google Drive in conjunction with Node.js to manage files efficiently.`
    },
    {
        title: "RESTful API with Node.js and MySQL",
        pic: "https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fhjehww5wq8p3cmdu7j9o.png",
        link: "https://dev.to/mearjuntripathi/building-a-restful-api-with-nodejs-and-mysql-1m77",
        codeLink: 'https://github.com/mearjuntripathi/nodejs/tree/main/crud-MySQL',
        category: "article",
        skills: ["Node.js", "Express.js", "MySQL", "Postman"],
        description: `We're introducing MySQL, a relational database management system, to store data securely.`
    },
    {
        title: "RESTful API with Express.js without database",
        pic: "https://github.com/mearjuntripathi/nodejs/raw/main/crud-RESTAPI/image/get.png",
        link: "https://dev.to/mearjuntripathi/building-a-student-data-management-restful-api-with-expressjs-without-database-115",
        codeLink: 'https://github.com/mearjuntripathi/nodejs/tree/main/crud-RESTAPI',
        category: "article",
        skills: ["Node.js", "Express.js"],
        description: `The process of building a RESTful API for managing student data using Node.js and the Express.js framework. This backend code tutorial assumes you have a working knowledge of JavaScript, Node.js, Express.js, and JSON.`
    },
    {
        title: "Gapshap",
        pic: project1Image,
        link: "https://replit.com/@mearjuntripathi/gapshap?v=1",
        codeLink: 'https://github.com/mearjuntripathi/Gapshap',
        category: "web development",
        skills: ["Node.js", "Express.js", "MongoDB", "React.js", "Socket.io"],
        description: `A chat application using Node.js, Express, and Socket.IO. Users can join a chat room, send messages to all users, or send private messages.`
    },
    {
        title: "DORA",
        pic: project4Image,
        link: "https://mearjuntripathi.github.io/dora/",
        codeLink: 'https://github.com/mearjuntripathi/mearjuntripathi.github.io/tree/main/dora',
        category: "web development",
        skills: ["JavaScript", "Wikipedia API", "Voice Recognition"],
        description: `An interactive app that uses the Wikipedia API and voice recognition to search and provide detailed information from Wikipedia.`
    },
    {
        title: "Stranger",
        pic: project5Image,
        link: "https://mearjuntripathi.github.io/stranger/",
        codeLink: 'https://github.com/mearjuntripathi/mearjuntripathi.github.io/tree/main/stranger',
        category: "web development",
        skills: ["JavaScript", "Scaledrone API"],
        description: `A Google Meet-like chat app using Scaledrone API for real-time two-person chat with unique key generation.`
    },
    {
        title: "Calculator",
        pic: project6Image,
        link: "https://mearjuntripathi.github.io/calculator/",
        codeLink: 'https://github.com/mearjuntripathi/mearjuntripathi.github.io/tree/main/calculator',
        category: "web development",
        skills: ["HTML", "CSS", "JavaScript"],
        description: `A basic calculator built with HTML, CSS, and JavaScript for essential arithmetic operations.`
    },
    {
        title: "ImagetoPDF",
        pic: project7Image,
        link: "https://mearjuntripathi.github.io/imagetopdf/",
        codeLink: 'https://github.com/mearjuntripathi/mearjuntripathi.github.io/tree/main/imagetopdf',
        category: "web development",
        skills: ["JavaScript", "PDF.js"],
        description: `Converts images to PDF files using JavaScript and PDF.js for simple image-to-document transformations.`
    },
    {
        title: "Tic Tac Toe",
        pic: project9Image,
        link: "https://mearjuntripathi.github.io/tictactoe/",
        codeLink: 'https://github.com/mearjuntripathi/Tic-Tac-Toe/tree/master',
        category: "web development",
        skills: ["JavaScript", "Socket.IO"],
        description: `A two-player Tic Tac Toe game with both local and online play options using the minimax algorithm for AI and Socket.IO for remote play.`
    },
    {
        title: "Code Editor",
        pic: project10Image,
        link: "https://mearjuntripathi.github.io/codeeditor/",
        codeLink: 'https://github.com/mearjuntripathi/mearjuntripathi.github.io/tree/main/codeeditor',
        category: "web development",
        skills: ["JavaScript", "Compiler API"],
        description: `An online code editor supporting multiple languages via a compiler API, providing an in-browser coding experience.`
    },
    {
        title: "DSA",
        pic: project11Image,
        codeLink: "https://github.com/mearjuntripathi/Data_Structure_Algorithm",
        category: "programming",
        skills: ["Java", "Data Structures", "Algorithms"],
        description: `A comprehensive repository of data structures and algorithms with a variety of questions and solutions.`
    },
    {
        title: "Chat Room",
        pic: project12Image,
        codeLink: "https://github.com/mearjuntripathi/Java/tree/main/Chat-Room",
        category: "programming",
        skills: ["Java", "WebSocket"],
        description: `A chat application using Java and WebSockets, allowing real-time communication via terminal.`
    },
    {
        title: "REST API",
        pic: project13Image,
        codeLink: "https://github.com/mearjuntripathi/nodejs/tree/main/crud-RESTAPI",
        category: "apis",
        skills: ["Node.js", "Express.js"],
        description: `A basic CRUD REST API in Node.js and Express, demonstrating essential API development without a database.`
    },
    {
        title: "Testhub",
        pic: project14Image,
        link: "https://explorer-app.github.io/testhub/",
        codeLink: "https://github.com/mearjuntripathi/Testhub-server",
        category: "web development",
        skills: ["Node.js", "React.js", "MySQL"],
        description: `A test platform for online exams with features to minimize cheating, using MySQL, Node, and React.`
    },
    {
        title: "Admin Panel",
        pic: project16Image,
        link: "https://mearjuntripathi.github.io/Admin-Panel/",
        codeLink: "https://github.com/mearjuntripathi/Admin-Panel",
        category: "web development",
        skills: ["HTML", "CSS", "JavaScript", "IconScout"],
        description: `A dummy admin panel built with HTML, CSS, and JavaScript featuring layout design and icons from IconScout.`
    },
    {
        title: "Book Management API",
        pic: project15Image,
        codeLink: "https://github.com/mearjuntripathi/book-management-api/",
        category: "apis",
        skills: ["Node.js", "JWT", "MVC"],
        description: `An API for book management built with Node.js, following MVC architecture with JWT for secure authentication.`
    },
    {
        title: "Rich Text Editor",
        pic: project18Image,
        link: "https://mearjuntripathi.github.io/blog-writer/",
        codeLink: "https://github.com/mearjuntripathi/mearjuntripathi.github.io/tree/main/blog-writer",
        category: "web development",
        skills: ["JavaScript", "HTML", "CSS"],
        description: `A rich text editor with functionalities similar to Microsoft Word, supporting text formatting and customization.`
    }
];

const CodingProfiles = [
    {
        platform: "LeetCode",
        username: "mearjuntripathi",
        link: "https://leetcode.com/mearjuntripathi",
        color: "#FFA116"
    },
    {
        platform: "HackerRank",
        username: "mearjuntripathi",
        link: "https://www.hackerrank.com/mearjuntripathi",
        color: "#2EC866"
    },
    {
        platform: "CodeChef",
        username: "isthisarjun",
        link: "https://www.codechef.com/users/isthisarjun",
        color: "#5B4638"
    },
    {
        platform: "GeeksforGeeks",
        username: "mearjuntripathi",
        link: "https://www.geeksforgeeks.org/user/mearjuntripathi",
        color: "#2F8D46"
    },
    {
        platform: "Codeforces",
        username: "isthisarjun",
        link: "https://codeforces.com/profile/isthisarjun",
        color: "#1890FF"
    }
];

const ConnectLinks = {
    github: {
        label: "GitHub",
        url: "https://github.com/mearjuntripathi",
        username: "mearjuntripathi",
        icon: "logo-github"
    },
    linkedin: {
        label: "LinkedIn",
        url: "https://www.linkedin.com/in/mearjuntripathi/",
        username: "mearjuntripathi",
        icon: "logo-linkedin"
    },
    twitter: {
        label: "Twitter / X",
        url: "https://x.com/mearjuntripathi",
        username: "@mearjuntripathi",
        icon: "logo-twitter"
    },
    google: {
        label: "Google Dev",
        url: "https://g.dev/mearjuntripathi",
        username: "mearjuntripathi",
        icon: "logo-google"
    },
    resume: {
        label: "Resume",
        url: "https://drive.google.com/file/d/1AU0YVDIEhOKu_g-yi-7DXbseyWCpQkl6/view?usp=sharing"
    },
    email: {
        label: "Email",
        url: "mailto:mearjuntripathi@gmail.com",
        username: "mearjuntripathi@gmail.com",
        icon: "mail-outline"
    }
}

export { Introduction, SocialAccount, AboutMe, ResumeData, Project, CodingProfiles, ConnectLinks }
